<template>
  <div>
    <section class="hero">
      <div class="container">
        <h1>{{ title }}</h1>
        <p>{{ subtitle }}</p>
      </div>
    </section>
    <!-- 模块标题区 -->
    <!-- <section class="modules-header">
      <div class="header-line"></div>
      <h2>{{ title }}</h2>
      <p>{{ subtitle }}</p>
    </section> -->
    <history-cases></history-cases>
    <Back></Back>
  </div>
</template>
  
<script>
import HistoryCases from '../components/HistoryCases.vue';
import Back from '../components/Back.vue';
export default {
  components: { HistoryCases, Back },
  name: "Cases",
  data() {
    return {
      title: "Core Service Cases of Enterprise Internationalization",
      subtitle: "Empower Enterprises to Set Sail Globally and Connect with Global Resources.",
    };
  }
};
</script>

<style scoped>
/* 标题区样式（匹配原站风格） */
.modules-header {
  background-color: #1a3b69;
  text-align: center;
  padding: 4rem 2rem 2rem;
}
.modules-header .header-line {
  width: 60px;
  height: 3px;
  background-color: #ff9f43; /* 橙色点缀 */
  margin: 0 auto 1rem;
}
.modules-header h1 {
  font-size: 2rem;
  color: #ffffff; /* 深蓝主色 */
  margin: 0;
}
.modules-header p {
  color: #eceef0;
  font-size: 1.1rem;
  margin-top: 0.8rem;
}
</style>